// extracted by mini-css-extract-plugin
module.exports = {"input":"add-price_input_az7tZ","inputContainer":"add-price_inputContainer_1PRal","label":"add-price_label_n2Uaw","alert":"add-price_alert_ZV7zn"};